import { useState } from 'react';
import { navLinks } from '@/mocks/homeNews';

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  return (
    <header className="w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center gap-6">
            <h1 className="flex items-center gap-2">
              <span className="flex items-center justify-center w-9 h-9 rounded-md bg-primary-600 text-background-50 font-heading text-lg font-bold">
                18
              </span>
              <span className="font-heading text-[22px] font-bold text-foreground-950 tracking-tight">
                黑料网
              </span>
            </h1>
            <nav className="hidden lg:flex items-center gap-1">
              {navLinks.map((link) => (
                <a
                  key={link.label}
                  href="#"
                  className={`px-3 py-2 text-[14px] rounded-md transition-colors whitespace-nowrap ${
                    link.active
                      ? 'bg-primary-50 text-primary-700 font-semibold'
                      : 'text-foreground-700 hover:bg-background-100 hover:text-foreground-950'
                  }`}
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>

          <div className="flex items-center gap-2">
            <div className="hidden md:flex items-center gap-2 bg-background-100 border border-background-200 rounded-md px-3 py-2 w-[220px]">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-search-line text-[15px] text-foreground-500" />
              </span>
              <input
                type="text"
                placeholder="搜索人物 / 事件"
                className="w-full bg-transparent text-[13px] text-foreground-800 placeholder:text-foreground-400 outline-none"
              />
            </div>
            <button
              type="button"
              onClick={() => setSearchOpen((v) => !v)}
              className="md:hidden w-9 h-9 flex items-center justify-center rounded-md border border-background-200 text-foreground-700"
              aria-label="搜索"
            >
              <i className="ri-search-line text-[17px]" />
            </button>
            <a
              href="#subscribe"
              className="hidden sm:flex items-center gap-1.5 bg-primary-600 hover:bg-primary-700 text-background-50 text-[13px] font-semibold px-4 py-2 rounded-md transition-colors whitespace-nowrap"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-notification-3-line text-[15px]" />
              </span>
              订阅追踪
            </a>
            <button
              type="button"
              onClick={() => setMenuOpen((v) => !v)}
              className="lg:hidden w-9 h-9 flex items-center justify-center rounded-md border border-background-200 text-foreground-700"
              aria-label="菜单"
            >
              <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-[17px]`} />
            </button>
          </div>
        </div>
      </div>

      {searchOpen && (
        <div className="md:hidden border-t border-background-200 px-4 py-3">
          <div className="flex items-center gap-2 bg-background-100 border border-background-200 rounded-md px-3 py-2">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-search-line text-[15px] text-foreground-500" />
            </span>
            <input
              type="text"
              placeholder="搜索人物 / 事件"
              className="w-full bg-transparent text-[13px] text-foreground-800 placeholder:text-foreground-400 outline-none"
            />
          </div>
        </div>
      )}

      {menuOpen && (
        <div className="lg:hidden border-t border-background-200 px-4 py-3">
          <nav className="grid grid-cols-2 gap-2">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href="#"
                className={`px-3 py-2 text-[14px] rounded-md ${
                  link.active
                    ? 'bg-primary-50 text-primary-700 font-semibold'
                    : 'text-foreground-700 bg-background-100'
                }`}
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}